<template>
    <div class="tw-grid tw-grid-cols-3 tw-gap-4 sm:tw-gap-x-16">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>
